var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c(
                "div",
                [
                  _vm.$checkPermission("ROUTES")
                    ? _c("crud-button", {
                        attrs: {
                          "x-large": "",
                          color: "light-blue lighten-2",
                          icon: "fa-plus",
                          tooltip: _vm.$t("global.crud.button.add")
                        },
                        on: {
                          clicked: function($event) {
                            return _vm.create()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              attrs: { lg: "2", sm: "12", md: "4", cols: "12" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.datatable.search"),
                                  "append-icon": "fas fa-search",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.filter.allFields,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "allFields", $$v)
                                  },
                                  expression: "filter.allFields"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { lg: "3", sm: "12", md: "4", cols: "12" }
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.agenciesOriginFilterItems,
                                  loading: _vm.agenciesOriginFilter.isLoading,
                                  "search-input":
                                    _vm.agenciesOriginFilter.search,
                                  "hide-no-data": "",
                                  "no-data-text": _vm.$t(
                                    "global.autocomplete.noDataFound"
                                  ),
                                  "item-text": "description",
                                  "item-value": "code",
                                  label: _vm.$t("routes.agencyOrigin"),
                                  placeholder: _vm.$t(
                                    "global.autocomplete.starTypingToSearch"
                                  ),
                                  clearable: ""
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    return _vm.$set(
                                      _vm.agenciesOriginFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  "update:search-input": function($event) {
                                    return _vm.$set(
                                      _vm.agenciesOriginFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.agenciesOriginFilter.isEdit = true
                                  },
                                  change: function($event) {
                                    _vm.agenciesOriginFilter.isEdit = false
                                  }
                                },
                                model: {
                                  value: _vm.filter.agencyOriginCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filter,
                                      "agencyOriginCode",
                                      $$v
                                    )
                                  },
                                  expression: "filter.agencyOriginCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            {
                              attrs: { lg: "2", sm: "12", md: "4", cols: "12" }
                            },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.agenciesDestinationFilterItems,
                                  loading:
                                    _vm.agenciesDestinationFilter.isLoading,
                                  "search-input":
                                    _vm.agenciesDestinationFilter.search,
                                  "hide-no-data": "",
                                  "no-data-text": _vm.$t(
                                    "global.autocomplete.noDataFound"
                                  ),
                                  "item-text": "description",
                                  "item-value": "code",
                                  label: _vm.$t("routes.agencyDestination"),
                                  placeholder: _vm.$t(
                                    "global.autocomplete.starTypingToSearch"
                                  ),
                                  clearable: ""
                                },
                                on: {
                                  "update:searchInput": function($event) {
                                    return _vm.$set(
                                      _vm.agenciesDestinationFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  "update:search-input": function($event) {
                                    return _vm.$set(
                                      _vm.agenciesDestinationFilter,
                                      "search",
                                      $event
                                    )
                                  },
                                  focus: function($event) {
                                    _vm.agenciesDestinationFilter.isEdit = true
                                  },
                                  change: function($event) {
                                    _vm.agenciesDestinationFilter.isEdit = false
                                  }
                                },
                                model: {
                                  value: _vm.filter.agencyDestinationCode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filter,
                                      "agencyDestinationCode",
                                      $$v
                                    )
                                  },
                                  expression: "filter.agencyDestinationCode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "3", sm: "6", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref:
                                    "dialogFilterAutoschedulingCutOffTimeFrom",
                                  attrs: {
                                    "return-value":
                                      _vm.filter
                                        .autoschedulingCutOffTimeFromString,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "autoschedulingCutOffTimeFromString",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "autoschedulingCutOffTimeFromString",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "routes.autoschedulingCutOffTimeFrom"
                                                  ),
                                                  readonly: "",
                                                  clearable: "",
                                                  "append-icon": "far fa-clock"
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter
                                                      .autoschedulingCutOffTimeFromString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "autoschedulingCutOffTimeFromString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.autoschedulingCutOffTimeFromString"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value:
                                      _vm.modalFilterAutoschedulingCutOffTimeFrom,
                                    callback: function($$v) {
                                      _vm.modalFilterAutoschedulingCutOffTimeFrom = $$v
                                    },
                                    expression:
                                      "modalFilterAutoschedulingCutOffTimeFrom"
                                  }
                                },
                                [
                                  _vm.modalFilterAutoschedulingCutOffTimeFrom
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            "full-width": "",
                                            format: "24hr",
                                            "allowed-minutes":
                                              _vm.allowedStepTime
                                          },
                                          on: {
                                            "click:minute": function($event) {
                                              return _vm.$refs.dialogFilterAutoschedulingCutOffTimeFrom.save(
                                                _vm.filter
                                                  .autoschedulingCutOffTimeFromString
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.filter
                                                .autoschedulingCutOffTimeFromString,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filter,
                                                "autoschedulingCutOffTimeFromString",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filter.autoschedulingCutOffTimeFromString"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.modalFilterAutoschedulingCutOffTimeFrom = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("global.cancel")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { lg: "2", sm: "6", cols: "12" } },
                            [
                              _c(
                                "v-dialog",
                                {
                                  ref: "dialogFilterAutoschedulingCutOffTimeTo",
                                  attrs: {
                                    "return-value":
                                      _vm.filter
                                        .autoschedulingCutOffTimeToString,
                                    persistent: "",
                                    width: "290px"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "autoschedulingCutOffTimeToString",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "autoschedulingCutOffTimeToString",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function({ on }) {
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "routes.autoschedulingCutOffTimeTo"
                                                  ),
                                                  readonly: "",
                                                  clearable: "",
                                                  "append-icon": "far fa-clock"
                                                },
                                                model: {
                                                  value:
                                                    _vm.filter
                                                      .autoschedulingCutOffTimeToString,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filter,
                                                      "autoschedulingCutOffTimeToString",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filter.autoschedulingCutOffTimeToString"
                                                }
                                              },
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value:
                                      _vm.modalFilterAutoschedulingCutOffTimeTo,
                                    callback: function($$v) {
                                      _vm.modalFilterAutoschedulingCutOffTimeTo = $$v
                                    },
                                    expression:
                                      "modalFilterAutoschedulingCutOffTimeTo"
                                  }
                                },
                                [
                                  _vm.modalFilterAutoschedulingCutOffTimeTo
                                    ? _c(
                                        "v-time-picker",
                                        {
                                          attrs: {
                                            "full-width": "",
                                            format: "24hr",
                                            "allowed-minutes":
                                              _vm.allowedStepTime
                                          },
                                          on: {
                                            "click:minute": function($event) {
                                              return _vm.$refs.dialogFilterAutoschedulingCutOffTimeTo.save(
                                                _vm.filter
                                                  .autoschedulingCutOffTimeToString
                                              )
                                            }
                                          },
                                          model: {
                                            value:
                                              _vm.filter
                                                .autoschedulingCutOffTimeToString,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filter,
                                                "autoschedulingCutOffTimeToString",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filter.autoschedulingCutOffTimeToString"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.modalFilterAutoschedulingCutOffTimeTo = false
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("global.cancel")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.refreshItemsView()
                      }
                    }
                  }),
                  _c("ExportExcel", {
                    attrs: {
                      url: "/routes",
                      filter: this.filter,
                      filterExport: _vm.filterExport
                    }
                  }),
                  _vm.$checkPermission("ROUTES")
                    ? _c("ImportExcel", {
                        attrs: { url: "/routes" },
                        on: { done: _vm.search }
                      })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c(
                            "tr",
                            {
                              key:
                                item.agencyOriginCode +
                                item.agencyDestinationCode
                            },
                            [
                              _c(
                                "td",
                                [
                                  _vm.$checkPermission("ROUTES")
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "orange",
                                          icon: "fa-pen",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.edit"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.edit(
                                              item.agencyOriginCode,
                                              item.agencyDestinationCode
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  (item.deletionDate === undefined ||
                                    item.deletionDate === null) &&
                                  _vm.$checkPermission("ROUTES")
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "red",
                                          icon: "fa-trash",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.delete"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.suspend(
                                              item.agencyOriginCode,
                                              item.agencyDestinationCode
                                            )
                                          }
                                        }
                                      })
                                    : _vm.$checkPermission("ROUTES")
                                    ? _c("crud-button", {
                                        attrs: {
                                          "x-small": "",
                                          color: "green",
                                          icon: "fa-redo",
                                          tooltip: _vm.$t(
                                            "global.crud.buttons.restore"
                                          )
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.restore(
                                              item.agencyOriginCode,
                                              item.agencyDestinationCode
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { right: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on }) {
                                              return [
                                                _c("span", _vm._g({}, on), [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.agencyOrigin.code
                                                    )
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(item.agencyOrigin.name))
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "td",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { right: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function({ on }) {
                                              return [
                                                _c("span", _vm._g({}, on), [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.agencyDestination
                                                        .code
                                                    )
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(item.agencyDestination.name)
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("td", [_vm._v(_vm._s(item.offsetDays))]),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.minutesToHour(
                                        item.autoschedulingCutOffTime
                                      )
                                    ) +
                                    " "
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ]),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "600",
            persistent: "",
            "no-click-animation": ""
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("validation-observer", {
            ref: "obs",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ invalid, validated, passes }) {
                  return [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-toolbar",
                          {
                            attrs: {
                              dark: "",
                              color: "primary",
                              dense: "",
                              flat: ""
                            }
                          },
                          [
                            _c(
                              "v-toolbar-title",
                              { staticClass: "white--text" },
                              [_vm._v(" " + _vm._s(_vm.formTitle) + " ")]
                            ),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("fas fa-times")])],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          { staticClass: "details-list" },
                          [
                            _c(
                              "v-form",
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        !_vm.editMode
                                          ? _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "routes.agencyOrigin"
                                                ),
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            items:
                                                              _vm.agenciesOriginItems,
                                                            loading:
                                                              _vm.agenciesOrigin
                                                                .isLoading,
                                                            "search-input":
                                                              _vm.agenciesOrigin
                                                                .search,
                                                            "hide-no-data": "",
                                                            "no-data-text": _vm.$t(
                                                              "global.autocomplete.noDataFound"
                                                            ),
                                                            "item-text":
                                                              "description",
                                                            "item-value":
                                                              "code",
                                                            label: _vm.$t(
                                                              "routes.agencyOrigin"
                                                            ),
                                                            placeholder: _vm.$t(
                                                              "global.autocomplete.starTypingToSearch"
                                                            ),
                                                            "error-messages": errors,
                                                            clearable: ""
                                                          },
                                                          on: {
                                                            "update:searchInput": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agenciesOrigin,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            "update:search-input": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agenciesOrigin,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            focus: function(
                                                              $event
                                                            ) {
                                                              _vm.agenciesOrigin.isEdit = true
                                                            },
                                                            change: function(
                                                              $event
                                                            ) {
                                                              _vm.agenciesOrigin.isEdit = false
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .agencyOriginCode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "agencyOriginCode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.agencyOriginCode"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "routes.agencyOrigin"
                                                ),
                                                disabled: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.item.agencyOriginString,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "agencyOriginString",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.agencyOriginString"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        !_vm.editMode
                                          ? _c("validation-provider", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "routes.agencyDestination"
                                                ),
                                                rules: "required"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function({ errors }) {
                                                      return [
                                                        _c("v-autocomplete", {
                                                          attrs: {
                                                            items:
                                                              _vm.agenciesDestinationItems,
                                                            loading:
                                                              _vm
                                                                .agenciesDestination
                                                                .isLoading,
                                                            "search-input":
                                                              _vm
                                                                .agenciesDestination
                                                                .search,
                                                            "hide-no-data": "",
                                                            "no-data-text": _vm.$t(
                                                              "global.autocomplete.noDataFound"
                                                            ),
                                                            "item-text":
                                                              "description",
                                                            "item-value":
                                                              "code",
                                                            label: _vm.$t(
                                                              "routes.agencyDestination"
                                                            ),
                                                            placeholder: _vm.$t(
                                                              "global.autocomplete.starTypingToSearch"
                                                            ),
                                                            "error-messages": errors,
                                                            clearable: ""
                                                          },
                                                          on: {
                                                            "update:searchInput": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agenciesDestination,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            "update:search-input": function(
                                                              $event
                                                            ) {
                                                              return _vm.$set(
                                                                _vm.agenciesDestination,
                                                                "search",
                                                                $event
                                                              )
                                                            },
                                                            focus: function(
                                                              $event
                                                            ) {
                                                              _vm.agenciesDestination.isEdit = true
                                                            },
                                                            change: function(
                                                              $event
                                                            ) {
                                                              _vm.agenciesDestination.isEdit = false
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.item
                                                                .agencyDestinationCode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.item,
                                                                "agencyDestinationCode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "item.agencyDestinationCode"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          : _c("v-text-field", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "routes.agencyDestination"
                                                ),
                                                disabled: ""
                                              },
                                              model: {
                                                value:
                                                  _vm.item
                                                    .agencyDestinationString,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.item,
                                                    "agencyDestinationString",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "item.agencyDestinationString"
                                              }
                                            })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("routes.offsetDays"),
                                            rules: "required|max:100"
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ errors }) {
                                                  return [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "routes.offsetDays"
                                                        ),
                                                        required: "",
                                                        "error-messages": errors
                                                      },
                                                      on: {
                                                        keypress: function(
                                                          $event
                                                        ) {
                                                          return _vm.integerOnlyField(
                                                            $event
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.item.offsetDays,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.item,
                                                            "offsetDays",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.offsetDays"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-layout",
                                  { attrs: { row: "", wrap: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { staticClass: "sm12" },
                                      [
                                        _c(
                                          "v-dialog",
                                          {
                                            ref:
                                              "dialogAutoschedulingCutOffTime",
                                            attrs: {
                                              "return-value":
                                                _vm.item
                                                  .autoschedulingCutOffTimeString,
                                              persistent: "",
                                              width: "290px"
                                            },
                                            on: {
                                              "update:returnValue": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.item,
                                                  "autoschedulingCutOffTimeString",
                                                  $event
                                                )
                                              },
                                              "update:return-value": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.item,
                                                  "autoschedulingCutOffTimeString",
                                                  $event
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function({ on }) {
                                                    return [
                                                      _c(
                                                        "validation-provider",
                                                        {
                                                          attrs: {
                                                            name: _vm.$t(
                                                              "routes.autoschedulingCutOffTime"
                                                            ),
                                                            vid:
                                                              "fieldAutoschedulingCutOffTime"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "default",
                                                                fn: function({
                                                                  errors
                                                                }) {
                                                                  return [
                                                                    _c(
                                                                      "v-text-field",
                                                                      _vm._g(
                                                                        {
                                                                          attrs: {
                                                                            label: _vm.$t(
                                                                              "routes.autoschedulingCutOffTime"
                                                                            ),
                                                                            readonly:
                                                                              "",
                                                                            clearable:
                                                                              "",
                                                                            "append-icon":
                                                                              "far fa-clock",
                                                                            "error-messages": errors
                                                                          },
                                                                          model: {
                                                                            value:
                                                                              _vm
                                                                                .item
                                                                                .autoschedulingCutOffTimeString,
                                                                            callback: function(
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.item,
                                                                                "autoschedulingCutOffTimeString",
                                                                                $$v
                                                                              )
                                                                            },
                                                                            expression:
                                                                              "item.autoschedulingCutOffTimeString"
                                                                          }
                                                                        },
                                                                        on
                                                                      )
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        }
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value:
                                                _vm.modalAutoschedulingCutOffTime,
                                              callback: function($$v) {
                                                _vm.modalAutoschedulingCutOffTime = $$v
                                              },
                                              expression:
                                                "modalAutoschedulingCutOffTime"
                                            }
                                          },
                                          [
                                            _vm.modalAutoschedulingCutOffTime
                                              ? _c(
                                                  "v-time-picker",
                                                  {
                                                    attrs: {
                                                      "full-width": "",
                                                      format: "24hr",
                                                      "allowed-minutes":
                                                        _vm.allowedStepTime
                                                    },
                                                    on: {
                                                      "click:minute": function(
                                                        $event
                                                      ) {
                                                        return _vm.$refs.dialogAutoschedulingCutOffTime.save(
                                                          _vm.item
                                                            .autoschedulingCutOffTimeString
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.item
                                                          .autoschedulingCutOffTimeString,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.item,
                                                          "autoschedulingCutOffTimeString",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "item.autoschedulingCutOffTimeString"
                                                    }
                                                  },
                                                  [
                                                    _c("v-spacer"),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          text: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            _vm.modalAutoschedulingCutOffTime = false
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.cancel"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          text: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.$refs.dialogAutoschedulingCutOffTime.save(
                                                              _vm.item
                                                                .autoschedulingCutOffTimeString
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "global.confirm"
                                                              )
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "black", text: "" },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.close()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("global.buttons.close")) +
                                    " "
                                )
                              ]
                            ),
                            _vm.editMode
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "orange", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.update)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.update")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "green", text: "" },
                                    on: {
                                      click: function($event) {
                                        return passes(_vm.save)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("global.buttons.create")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }